import React, { useEffect } from "react";
import { Form } from "react-final-form";
import MakeAsyncFunction from "react-redux-promise-listener";
import { promiseListener } from "../../../helpers/store";
import {
  ADD_ACCESSORY_ERROR,
  ADD_ACCESSORY_REQUEST,
  ADD_ACCESSORY_RESPONSE,
} from "../../../actions/accessories.actions";
import { Button } from "@material-ui/core";
import AccessoriesForm from "./AccessoriesForm";
import Box from "@material-ui/core/Box";
import { useDispatch } from "react-redux";
import { appActions } from "../../../actions/app.actions";

export default function ClientsNew() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(appActions.setNextPage("/renov/accessories"));
  }, [dispatch]);
  return (
    <div>
      <MakeAsyncFunction
        listener={promiseListener}
        start={ADD_ACCESSORY_REQUEST}
        resolve={ADD_ACCESSORY_RESPONSE}
        reject={ADD_ACCESSORY_ERROR}
      >
        {(onSubmit) => (
          <Form
            mutators={{
              setValue: ([field, value], state, { changeValue }) => {
                changeValue(state, field, () => value);
              },
            }}
            initialValues={{ enabled: true }}
            onSubmit={(form) => {
              form.price = parseFloat(form.price);
              return onSubmit(form);
            }}
            render={({ handleSubmit, submitting, values, form, valid }) => (
              <form onSubmit={handleSubmit}>
                <AccessoriesForm setValue={form.mutators.setValue} />

                <Box mt={1} display="flex" justifyContent="flex-end">
                  <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                    disabled={submitting}
                  >
                    Ajouter
                  </Button>
                </Box>
              </form>
            )}
          />
        )}
      </MakeAsyncFunction>
    </div>
  );
}
